/* nord-timeline — JS estático extraído do <script> inline.
   Sem Liquid: idêntico em toda página, então vira asset cacheável. */
if (!customElements.get('nord-timeline')) {
    customElements.define(
      'nord-timeline',
      class NordTimeline extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          this.mediaItems = Array.from(this.querySelectorAll('.nord-timeline__media-item'));
          this.index = 0;
          this.timer = null;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i, true));
            tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
          });

          this.touchStartX = null;
          this.addEventListener('touchstart', (e) => {
            this.touchStartX = e.changedTouches[0].clientX;
          }, { passive: true });
          this.addEventListener('touchend', (e) => {
            if (this.touchStartX === null) return;
            const dx = e.changedTouches[0].clientX - this.touchStartX;
            this.touchStartX = null;
            if (Math.abs(dx) < 40) return;
            this.select(this.clamp(this.index + (dx < 0 ? 1 : -1)), true);
          }, { passive: true });

          this.addEventListener('pointerenter', () => this.stop());
          this.addEventListener('pointerleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());

          this.userStopped = false;
          this.start();
        }

        disconnectedCallback() {
          this.stop();
        }

        clamp(i) {
          const n = this.tabs.length;
          return ((i % n) + n) % n;
        }

        onKeydown(event, i) {
          let target = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = this.clamp(i + 1);
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = this.clamp(i - 1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === null) return;
          event.preventDefault();
          this.select(target, true);
          this.tabs[target].focus();
        }

        select(i, byUser) {
          if (i === this.index && byUser !== 'init') return;
          this.index = i;
          if (byUser === true) {
            this.userStopped = true;
            this.stop();
          }
          this.tabs.forEach((tab, j) => {
            tab.setAttribute('aria-selected', j === i ? 'true' : 'false');
            if (j === i) tab.removeAttribute('tabindex');
            else tab.setAttribute('tabindex', '-1');
          });
          this.panels.forEach((panel, j) => {
            panel.classList.toggle('is-active', j === i);
            if (j === i) panel.removeAttribute('hidden');
            else setTimeout(() => panel.setAttribute('hidden', ''), 400);
          });
          this.mediaItems.forEach((item, j) => {
            item.classList.toggle('is-active', j === i);
          });
        }

        start() {
          if (this.dataset.autoplay !== 'true') return;
          if (this.reducedMotion || this.userStopped || this.timer) return;
          const speed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
          this.timer = setInterval(() => {
            this.select(this.clamp(this.index + 1), false);
          }, speed);
        }

        stop() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      }
    );
  }
